<div class="main">
  <!-- <f-alert variant="warning" in-container>
    <p>We are working through a subscription feature outage. As we work to resolve, you or your account manager can export the report information you need by selecting the report on the Reports & Dashboards page and selecting export to CSV or Excel.</p>
  </f-alert> -->

  <h1>Subscriptions</h1>

  @if (isLoading) {
    <app-loading></app-loading>
  } @else {

  <f-modal has-close role="dialog" size="medium" variant="dialog" position="center"
    [visible]="isNotificationModalVisible" aria-modal="true"
    (modalClosed)="closeNotificationModal()">
    <div style="margin-bottom: 12px;">
      <h4>{{ alertVariant === 'success' ? 'Success' : 'Error' }}</h4>
    </div>
    <div>
      <p>{{ alertMessage }}</p>
    </div>
    <div class="modal-footer">
      <f-button type="button" variant="progressive" text="OK" (buttonClicked)="closeNotificationModal()"></f-button>
    </div>
  </f-modal>

  <p class="subscriptions-items-label">{{subscriptions.length}} items</p>
  <div class="subscriptions-table">
    <f-table auto-sort>
      <table role="table" aria-colcount="7">
        <caption class="screen-reader-text">
          This is a table containing all user subscriptions .
        </caption>
        <thead>
          <tr role="row">
            <th data-type="string" class="text-align-left w-15" role="columnheader">
              Subscription Name
            </th>
            <th data-type="string" class="text-align-left w-15" role="columnheader">
              Title
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Format
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Last Successful Timestamp [US Central]
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Download
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          @for (sub of subscriptions; track sub.subscriptionId) {
          <tr role="row">
            <td role="cell">
              <a (click)="onSubscriptionClick(sub)">{{ sub.subscriptionName }}</a>
            </td>
            <td role="cell">
              {{ sub.title }}
            </td>
            <td role="cell" class="text-wrap-nowrap">
              {{sub.format}}
            </td>
            <td role="cell" class="text-align-left">
              {{formatTimestamp(sub.endDttm)}}
            </td>
            <td role="cell" class="text-align-left">
              <ng-container *ngIf="sub.storageURL && sub.storageURL.length > 0; else viewReport">
                <a (click)="onDownloadClick(sub.storageURL, sub)">Download Latest</a>
              </ng-container>
              <ng-template #viewReport>
                <a (click)="onViewReportClick(sub)">View Report</a>
              </ng-template>
            </td>
            <td role="cell" class="text-align-left">
              <div *ngFor="let option of basicTableActionTypes" class="option-link">
                <f-link  text={{option.name}} (linkClicked)="onOverflowItemClicked(option, sub)" />
              </div>
              <!-- <f-link text="Edit" /> -->
              <!-- <a (click)="onEditClick(sub)">Edit</a> -->
              <!-- <f-overflow-menu variant="naked" [overflowItems]="basicTableActionTypes" [overflowText]="''"
                [overflowIconConfig]="actionsIconConfig" is-icon-only="true" uuid="f-overflow-menu-2"
                (overflowItemSelected)="onOverflowItemSelected($event, sub)">
              </f-overflow-menu> -->
            </td>
          </tr>
          }
        </tbody>
      </table>
    </f-table>
  </div>
  <f-modal has-close role="dialog" size="large" variant="dialog" position="center" [visible]="isDeleteSubscriptionModalVisible" aria-modal="true">
    <div style= "margin-bottom: 12px">
        <H4>Delete subscription: {{subscriptionToDelete?.title}}</H4>
    </div>
    <div>
        <p style="font-size:15px;">Are you sure?</p>
    </div>
    <div class="modal-footer">
        <f-button type="button" variant="action" text="Cancel" (buttonClicked)="onModalDeleteCancelButtonClicked()"></f-button>
        <f-button type="button" variant="progressive" text="Delete" (buttonClicked)="onModalDeleteButtonClicked()"></f-button>
    </div>
</f-modal>
  } <!-- end @else -->
</div>